/* import __COLOCATED_TEMPLATE__ from './maybe-in-element.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();